(function () {
let $defd06e0b31da822$var$subscribers = {};
function $defd06e0b31da822$var$publish(eventName, data) {
    if ($defd06e0b31da822$var$subscribers[eventName]) {
        const promises = $defd06e0b31da822$var$subscribers[eventName].map((callback)=>callback(data));
        return Promise.all(promises);
    } else return Promise.resolve();
}
const $defd06e0b31da822$var$PUB_SUB_EVENTS = {
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change'
};
class $defd06e0b31da822$var$VariantSelects extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            formInput: ".js-lsg-pdp-form-input"
        };
        this.addEventListener('change', this.onVariantChange);
    }
    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updateSelectedSwatchValue(event);
        this.toggleAddButton(true, window.variantStrings.addToCart, false);
        this.updateVariantStatuses();
        if (!this.currentVariant) {
            this.toggleAddButton(true, window.variantStrings.unavailable, true);
            this.setUnavailable();
        } else {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
        const checkedInput = this.querySelector('input[type="radio"]:checked');
        document.querySelectorAll(`.js-option-select[data-option-value="${checkedInput.value}"]`)?.forEach((option)=>{
            option.click();
        });
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element)=>{
            if (element.tagName === 'SELECT') return element.value;
            if (element.tagName === 'FIELDSET') return Array.from(element.querySelectorAll('input')).find((radio)=>radio.checked)?.value;
        });
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant)=>{
            return !variant.options.map((option, index)=>{
                return this.options[index] === option;
            }).includes(false);
        });
    }
    updateSelectedSwatchValue({ target: target }) {
        const { value: value, tagName: tagName } = target;
        if (tagName === 'INPUT' && target.type === 'radio') {
            const selectedSwatchValue = target.closest(this.selectors.formInput).querySelector('[data-selected-value]');
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
    }
    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
        productForms.forEach((productForm)=>{
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
    }
    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter((variant)=>this.querySelector(':checked').value === variant.option1);
        const inputWrappers = [
            ...this.querySelectorAll(this.selectors.formInput)
        ];
        inputWrappers.forEach((option, index)=>{
            if (index === 0) return;
            const optionInputs = [
                ...option.querySelectorAll('input[type="radio"], option')
            ];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter((variant)=>variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption)=>variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }
    setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element)=>{
            const value = element.getAttribute('value');
            const availableElement = availableValuesList.includes(value);
            if (element.tagName === 'INPUT') element.classList.toggle('disabled', !availableElement);
            else if (element.tagName === 'OPTION') element.innerText = availableElement ? value : window.variantStrings.unavailable_with_option.replace('[value]', value);
        });
    }
    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.section;
        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.section}`).then((response)=>response.text()).then((responseText)=>{
            if (this.currentVariant.id !== requestedVariantId) return;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            if (!document.querySelector('lsg-pdp-bundle-widget')) {
                const priceDestination = document.getElementById(`price-${this.dataset.section}`);
                const priceSource = html.getElementById(`price-${this.dataset.section}`);
                if (priceSource && priceDestination) {
                    priceDestination.innerHTML = priceSource.innerHTML;
                    const stickyPriceDestination = document.querySelector(".b-pdp-sticky-cta__price");
                    if (stickyPriceDestination != null) stickyPriceDestination.innerHTML = priceSource.innerHTML;
                }
                const stickyCompareDestination = document.querySelector(".b-pdp-sticky-cta__compare-price");
                if (stickyCompareDestination != null) stickyCompareDestination.innerHTML = priceSource.innerHTML;
                const stickyPercentDestination = document.querySelector(".b-pdp-sticky-cta__percentage-off");
                if (stickyPercentDestination != null) stickyPercentDestination.innerHTML = priceSource.innerHTML;
                if (priceDestination) priceDestination.classList.remove('hidden');
            } else {
                const priceDestination = document.getElementById(`price-${this.dataset.section}`);
                const priceSource = html.getElementById(`price-${this.dataset.section}`);
                if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
                const bundleWidget = document.querySelector('lsg-pdp-bundle-widget');
                const productGroup = bundleWidget.querySelector('.js-product-select.js-product-select-default');
                if (priceSource && productGroup) {
                    const sourceCompare = priceSource.querySelector('.c-price__list');
                    const sourcePrice = priceSource.querySelector('.c-price__retail');
                    const sourcePercent = priceSource.querySelector('.c-price__percent');
                    const groupCompare = productGroup.querySelector('.js-compare');
                    const groupPrice = productGroup.querySelector('.js-price');
                    const groupPercent = productGroup.querySelector('.js-percent');
                    if (sourceCompare && groupCompare) groupCompare.innerHTML = sourceCompare.innerHTML;
                    if (sourcePrice && groupPrice) groupPrice.innerHTML = sourcePrice.innerHTML;
                    if (sourcePercent && groupPercent) groupPercent.innerHTML = sourcePercent.innerHTML;
                }
            }
            const galleryDestination = document.getElementById(`Gallery-${this.dataset.section}`);
            const gallerySource = html.getElementById(`Gallery-${this.dataset.section}`);
            if (gallerySource && galleryDestination) galleryDestination.innerHTML = gallerySource.innerHTML;
            const gallerySliderDestination = document.getElementById(`Gallery-Slider-${this.dataset.section}`);
            const gallerySliderSource = html.getElementById(`Gallery-Slider-${this.dataset.section}`);
            if (gallerySliderSource && gallerySliderDestination) {
                gallerySliderDestination.innerHTML = gallerySliderSource.innerHTML;
                window?.initMediaPDP();
                window?.initMediaPDPSlider();
            }
            const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
            $defd06e0b31da822$var$publish($defd06e0b31da822$var$PUB_SUB_EVENTS.variantChange, {
                data: {
                    sectionId: sectionId,
                    html: html,
                    variant: this.currentVariant
                }
            });
        });
    }
    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButtons = productForm.querySelectorAll('[type="submit"]');
        const addButtonsSticky = document.querySelectorAll('.b-pdp-sticky-cta .trigger-add-to-cart');
        addButtons.forEach((addButton)=>{
            const addButtonText = addButton;
            if (disable) {
                addButton.setAttribute('disabled', 'disabled');
                if (text) addButtonText.textContent = text;
            } else {
                addButton.removeAttribute('disabled');
                addButtonText.textContent = window.variantStrings.addToCart;
            }
        });
        addButtonsSticky.forEach((addButton)=>{
            const addButtonText = addButton;
            if (disable) {
                addButton.setAttribute('disabled', 'disabled');
                if (text) addButtonText.textContent = text;
            } else {
                addButton.removeAttribute('disabled');
                addButtonText.textContent = window.variantStrings.addToCart;
                if (!document.querySelector('lsg-pdp-bundle-widget') || document.querySelector('.js-product-select-default.active')) addButton.setAttribute("data-product-id", this.currentVariant.id);
            }
        });
        if (!modifyClass) return;
    }
    setUnavailable() {}
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define('lsg-variant-selects', $defd06e0b31da822$var$VariantSelects);

})();
